<div class="ai-support-chat">
    <button
        mat-flat-button
        class="chat-toggle"
        type="button"
        (click)="toggleChat()"
        *ngIf="!isOpen"
        aria-label="Open support chat"
    >
        <mat-icon>chat_bubble</mat-icon>
        <span>Need help?</span>
    </button>

    <section class="chat-panel" *ngIf="isOpen">
        <header>
            <div class="title">
                <h3>Support</h3>
                <p>AI assistant with human backup</p>
            </div>
            <div class="actions">
                <button mat-icon-button class="close-button icon-button-overlay-remove" (click)="close()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </header>

        <div class="messages" #messageContainer>
            <div
                class="message"
                *ngFor="let message of messages"
                [ngClass]="{
                    user: message.sender === 'user',
                    assistant: message.sender === 'assistant',
                    system: message.sender === 'system'
                }"
            >
                <div class="bubble">
                    <p>{{ message.content }}</p>
                    <span class="timestamp" *ngIf="message.timestamp">{{ message.timestamp | date: "shortTime" }}</span>
                </div>
            </div>

            <div class="status" *ngIf="isSending">
                <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
                <span>Thinking...</span>
            </div>
        </div>

        <div class="handoff" *ngIf="!isHumanChatActive && isHumanRequestInFlight">
            <mat-icon>support_agent</mat-icon>
            <div>
                <p>Connecting you with the next available specialist…</p>
            </div>
        </div>

        <form class="input-row" (ngSubmit)="sendMessage()">
            <input
                type="text"
                placeholder="Ask a question..."
                [formControl]="messageControl"
                (keydown)="handleEnter($event)"
                aria-label="Message"
            />
            <button
                mat-icon-button
                class="send-button icon-button-overlay-remove"
                [disabled]="messageControl.invalid || isSending"
            >
                <mat-icon>send</mat-icon>
            </button>
        </form>
    </section>
</div>
